// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3-zmQ","consentsList":"PatientConsents_consentsList__4zp12","consentsListEmpty":"PatientConsents_consentsListEmpty__3YNXB"};